import { render, staticRenderFns } from "./Finalize.vue?vue&type=template&id=567307e2&"
import script from "./Finalize.vue?vue&type=script&lang=ts&"
export * from "./Finalize.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports